import Vue from "vue";

if (!window.bus) {
    window.bus = new Vue();
}
const bus = window.bus;

const EVENT_USER_LOGIN = "user.login";
const EVENT_USER_AUTH_ERROR = "user.auth";
const EVENT_MARKED_ALL_AS_READ = "allread";
const EVENT_NEW_MESSAGE = "msg.action";
const EVENT_UPDATE_CONTACT = "msg.unread";
const EVENT_ONESIGNAL_TOKEN_EXPIRED = "onesignal.expired";
const EVENT_PROFILE_UPDATED = "profile.updated";

const EventBus = {
    on(eventName, callback) {
        return bus.$on(eventName, callback);
    },
    off(eventName, callback = null) {
        return bus.$off(eventName, callback);
    },
    $emit(eventName, ...params) {
        return this.dispatch(eventName, ...params);
    },
    dispatch(eventName, ...params) {
        bus.$emit(eventName, ...params);
        return this;
    },
    dispatchAuthError() {
        return this.dispatch(EVENT_USER_AUTH_ERROR);
    },
    dispatchMarkedAllAsRead() {
        return this.dispatch(EVENT_MARKED_ALL_AS_READ);
    },
    dispatchNewMessage(e) {
        return this.dispatch(EVENT_NEW_MESSAGE, e);
    },
    dispatchContactUpdated(e) {
        return this.dispatch(EVENT_UPDATE_CONTACT, e);
    },
    dispatchUserLogin() {
        return this.dispatch(EVENT_USER_LOGIN);
    },
    dispatchOneSignalTokenExpired() {
        return this.dispatch(EVENT_ONESIGNAL_TOKEN_EXPIRED);
    },
    dispatchProfileUpdated() {
        return this.dispatch(EVENT_PROFILE_UPDATED);
    },
    $on(eventName, callback) {
        return this.on(eventName, callback);
    },
    $off(eventName, callback) {
        return this.off(eventName, callback);
    },
    onUserLogin(callback) {
        this.on(EVENT_USER_LOGIN, callback);
        return this;
    },
    offUserLogin(callback = null) {
        this.off(EVENT_USER_LOGIN, callback);
        return this;
    },
    onUserAuthError(callback) {
        this.on(EVENT_USER_AUTH_ERROR, callback);
        return this;
    },
    offUserAuthError(callback = null) {
        this.off(EVENT_USER_AUTH_ERROR, callback);
        return this;
    },
    onMarkedAllAsRead(callback) {
        this.on(EVENT_MARKED_ALL_AS_READ, callback);
        return this;
    },
    offMarkedAllAsRead(callback = null) {
        this.off(EVENT_MARKED_ALL_AS_READ, callback);
        return this;
    },
    onNewMessage(callback) {
        this.on(EVENT_NEW_MESSAGE, callback);
        return this;
    },
    offNewMessage(callback = null) {
        this.off(EVENT_NEW_MESSAGE, callback);
        return this;
    },
    onContactUpdated(callback) {
        this.on(EVENT_UPDATE_CONTACT, callback);
        return this;
    },
    offContactUpdated(callback = null) {
        this.off(EVENT_UPDATE_CONTACT, callback);
        return this;
    },
    onOneSignalTokenExpired(callback) {
        this.on(EVENT_ONESIGNAL_TOKEN_EXPIRED, callback);
        return this;
    },
    offOneSignalTokenExpired(callback = null) {
        this.off(EVENT_ONESIGNAL_TOKEN_EXPIRED, callback);
        return this;
    },
    onProfileUpdated(callback) {
        this.on(EVENT_PROFILE_UPDATED, callback);
        return this;
    },
    offProfileUpdated(callback = null) {
        this.off(EVENT_PROFILE_UPDATED, callback);
        return this;
    }
};

export {
    EventBus
}
